import React from 'react'
import { IconRecord } from 'types'

export const IconBlock = ({ record }: { record: IconRecord }) => (
  <img src={record.image.url} alt={record.image.alt} className="icon" />
)
